import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAuthButton, LazyBrand, LazyColorMode, LazyConfirmationDialog, LazyImpersonationBanner, LazyJsonDisplay, LazyJsonTreeView, LazyMyAudioPlayer, LazyPricingTable, LazyRichTextEditor, LazyTestModal, LazyTestTable, LazyUtilFunctions, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AuthButton", LazyAuthButton],
["Brand", LazyBrand],
["ColorMode", LazyColorMode],
["ConfirmationDialog", LazyConfirmationDialog],
["ImpersonationBanner", LazyImpersonationBanner],
["JsonDisplay", LazyJsonDisplay],
["JsonTreeView", LazyJsonTreeView],
["MyAudioPlayer", LazyMyAudioPlayer],
["PricingTable", LazyPricingTable],
["RichTextEditor", LazyRichTextEditor],
["TestModal", LazyTestModal],
["TestTable", LazyTestTable],
["UtilFunctions", LazyUtilFunctions],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
